import { z } from 'zod';
import { dataConnectionQueryTypeSchema } from '../types/data-connection-queries.js';
import { agentDataQueryRecordSchema } from '../types/agent-data-queries.js';

export namespace GetAgentDataConnectionQueries {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const querySchema = z.object({
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    items: z.array(agentDataQueryRecordSchema),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace GetAvailableDataConnectionQueries {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const querySchema = z.object({
    dataConnectionId: z.uuid(),
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    items: z.array(
      z.object({
        id: z.uuid(),
        name: z.string(),
        description: z.string(),
        queryType: dataConnectionQueryTypeSchema,
        dataConnectionId: z.uuid(),
      })
    ),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace AttachDataConnectionQueries {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const requestBodySchema = z.object({
    queryIds: z.array(z.uuid()).min(1),
    brandId: z.number().nullable().optional(),
  });

  export const responseSchema = z.object({
    success: z.boolean(),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace DetachDataConnectionQuery {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
    queryId: z.uuid(),
  });

  export const querySchema = z.object({
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    success: z.boolean(),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace UpdateDataConnectionQueryEnabled {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
    queryId: z.uuid(),
  });

  export const requestBodySchema = z.object({
    isEnabled: z.boolean(),
    brandId: z.number().nullable().optional(),
  });

  export const responseSchema = agentDataQueryRecordSchema;

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}
